export default "__VITE_ASSET__Cvy9OGuq__"